import { render, staticRenderFns } from "./List_2Col.vue?vue&type=template&id=11a5ab50"
import script from "./List_2Col.vue?vue&type=script&lang=js"
export * from "./List_2Col.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports